import { faBook, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import TableAdvanced from '../../../../../../../components/Tables/TableAdvanced/TableAdvanced'
import { useLang } from '../../../../../../../language'
import { TiposTarifaAplicadaAServices } from '../../../../../../../services/statics.service'
import { ModalTarifa } from './ModalTarifa'

export const TableTarifas = ({ data, loading, total, perPage, handleFormChange, formValuesSearch, setdataExcluidos,
    setimportesChangeList, importesChangeList, checkAll, setCheckAll, setIncluidos, setExcluidos, excluidos,
    incluidos, handleInputChangeSearch, urlParams, idevento, fetchTarifasGET, idaparato }: any) => {

    const Lang = useLang()

    const staticTiposTarifaAplicadaA: any = TiposTarifaAplicadaAServices.GET()

    const selectAllItems = () => {
        setCheckAll(true)
        setIncluidos([])
        setExcluidos([])
    }

    const unselectAllItems = () => {
        setCheckAll(false)
        setIncluidos([])
        setExcluidos([])
    }

    const allActions: any = [
        {
            label: <span className='me-2'><FontAwesomeIcon icon={faPlus} className='me-2' />{Lang('NUEVA_TARIFA')}</span>,
            variant: 'primary',
            action: () => handleShowModal_Documento({
                action: 'CREATE',
                idaparato,
            })
        },
    ]

    const allActionsPerLine: any = [
        {
            label: <FontAwesomeIcon icon={faBook} className='' />,
            action: (form: any) => handleShowModal_Documento({
                form,
                action: 'EDIT',
                idaparato,
            }),
            withoutID: true,
        },
    ]

    const handleChangeCheckAll = (e: any) => {

        if (e.target.checked) {

            selectAllItems()

        } else {

            unselectAllItems()
        }
    }


    const handleChangeInputLineTable = (e: any) => {

        setimportesChangeList({
            ...importesChangeList,
            [e.target.name]: e.target.value
        })
    }

    useEffect(() => {

        setdataExcluidos(excluidos)

    }, [excluidos])


    const headersTable = [
        <small>{Lang('TARIFA')}</small>,
        <small>
            {Lang('TARIFA_APLICADA_A')}
        </small>,
        <small>
            {Lang('IMPORTE_POR_DEFECTO')}
        </small>,
        ''
    ]

    const dataLineTable = [
        {
            className: '',
            name: 'tarifa',
        },
        {
            className: '',
            name: 'tarifaaplicadaa',
            adapter: staticTiposTarifaAplicadaA
        },
        {
            className: '',
            name: 'label__importe'
        },
    ]

    // Acciones



    // const [fetchDocumento, fetchDocumentoData] = useAxios({ 'get', `/dapcons/${idDapcon}/form/doc-adjuntos-obligatorios/obtener-documento`, '', 'blob'})
    const [fetchDocumentoData, setFetchDocumentoData] = useState<any>({ data: null, loading: null, error: null, status: null });

    const isMounted = useRef(true)

    useEffect(() => {
        return () => {
            isMounted.current = false;
        }
    }, [])

    const handleFetchFile = (url: any) => {

        setFetchDocumentoData({ data: null, loading: true, error: null, status: null })

        const config: any = { responseType: 'blob' };

        axios.get(url, config).then((response: any) => {
            setFetchDocumentoData({
                loading: false,
                error: null,
                data: response,
                status: response,
            });
        });
    }

    useEffect(() => {
        if (fetchDocumentoData.data) {

            // 2. Create blob link to download
            const docData = fetchDocumentoData.data

            const filename = docData?.headers?.['content-disposition']?.split('filename=')?.[1]
            const blobData = docData?.data

            const instanceBlob = new Blob([blobData])

            const date = new Date()

            const url = window.URL.createObjectURL(instanceBlob);
            const link: any = document.createElement('a');

            link.href = url;
            link.setAttribute('download', `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}_${filename}`);
            // 3. Append to html page
            document.body.appendChild(link);

            // 4. Force download
            link.click();

            // 5. Clean up and remove the link
            link.parentNode.removeChild(link);

            setFetchDocumentoData({ data: null, loading: true, error: null, status: null })

        }
    }, [fetchDocumentoData])


    // Descargar Excel

    // const [showConfirm_Excel, setshowConfirm_Excel] = useState(false)

    // const [fetchFacturasGETExcel, fetchFacturasGETExcelData, resetFacturasGETExcelData] = RemesasServices.GET_EXCEL()

    // useEffect(() => {

    //     if (fetchFacturasGETExcelData.status === 200) {
    //         getDataFile(fetchFacturasGETExcelData, resetFacturasGETExcelData, 'Remeses', 'xlsx')
    //         setshowConfirm_Excel(false)
    //     }
    // }, [fetchFacturasGETExcelData])

    // const handleClickExcel = () => {

    //     setshowConfirm_Excel(true)

    //     let urlParamsTemp = cloneDeep(urlParams)
    //     delete urlParamsTemp['page']

    //     fetchFacturasGETExcel({
    //         params: {
    //             ...urlParamsTemp,
    //             to_excel: 1
    //         }
    //     })
    // }


    // Crear nueva colegiatura

    const [showModal_Documento, setShowModal_Documento] = useState({
        value: false,
        payload: {}
    });

    const handleCloseModal_Documento = () => setShowModal_Documento({
        value: false,
        payload: {}
    });

    const handleShowModal_Documento = (payload: object) => setShowModal_Documento({
        value: true,
        payload
    });

    return (
        <>

            <TableAdvanced>

                <TableAdvanced.Head
                    title={Lang('NUEVA_TARIFA')}
                    allActions={allActions}
                />

                <TableAdvanced.Body
                    headers={headersTable}
                    dataLineTable={dataLineTable}
                    data={data}
                    isLoading={loading}

                    excluidos={excluidos}
                    incluidos={incluidos}
                    setExcluidos={setExcluidos}
                    setIncluidos={setIncluidos}

                    checkAll={checkAll}
                    allActionsPerLine={allActionsPerLine}
                    checkMultiples={false}
                />

                <TableAdvanced.Footer
                    total={total}
                    handleFormChange={handleFormChange}
                    formValuesSearch={formValuesSearch}
                    perPage={perPage}
                />

            </TableAdvanced>


            <ModalTarifa
                showModal_Documento={showModal_Documento}
                handleCloseModal_Documento={handleCloseModal_Documento}
                fetchTarifasGET={fetchTarifasGET}
                list={data}
            />

        </>
    )
}
